import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';

import TableContext from './TableContext';
import { TableRoot } from './TableStyles';
import { conditionalClassNames } from 'UtilityComponents/Util';

/**
 *
 * @param {String} padding
 * @param {String} size
 * @param {Boolean} stickyHeader
 * @param {Object} classes - {
 * root - Class that will get applied to all the Table element
 * stickyHeaderClass - Class that will get applied table with stickyHeader == true
 * }
 */

const Table = ({
	padding = 'default',
	size = 'medium',
	stickyHeader = false,
	classes = {},
	forwardedRef,
	...other
}) => {
	const table = useMemo(() => ({ padding, size, stickyHeader }), [
		padding,
		size,
		stickyHeader
	]);

	const { root, stickyHeader: stickyHeaderClass } = classes;
	const className = conditionalClassNames({
		[root]: root,
		[stickyHeaderClass]: stickyHeaderClass && stickyHeader
	});

	return (
		<TableContext.Provider value={table}>
			<TableRoot
				ref={forwardedRef}
				className={className}
				stickyHeader={stickyHeader}
				collapse={stickyHeader ? 'separate' : 'collapse'}
				{...other}
			/>
		</TableContext.Provider>
	);
};

Table.propTypes = {
	size: PropTypes.oneOf(['medium', 'small']),
	padding: PropTypes.oneOf(['default', 'checkbox', 'none']),
	stickyHeader: PropTypes.bool,
	classes: PropTypes.object
};

export default forwardRef((props, ref) => <Table {...props} forwardedRef={ref} />);
